import { LongpipeBackgroundProcessor } from '@/src/processor'

/** Показывает панель эффектов, когда доступны необходимые Longpipe браузерные API. */
export function isBackgroundEffectAvailable(): boolean {
  return LongpipeBackgroundProcessor.isSupported
}
